import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.195 4.195a.67.67 0 0 1 .839-.085l.104.085 3.333 3.334c.26.26.26.682 0 .942l-3.333 3.333-.104.086a.668.668 0 0 1-.839-1.028L13.057 8l-2.862-2.862-.085-.104a.67.67 0 0 1 .085-.839"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14 7.333.135.014a.667.667 0 0 1 0 1.306L14 8.667H6a.667.667 0 0 1 0-1.334z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.333 12.667V3.333a2 2 0 0 1 2-2H6l.135.014a.667.667 0 0 1 0 1.306L6 2.667H3.333a.666.666 0 0 0-.666.666v9.334a.666.666 0 0 0 .666.666H6a.667.667 0 0 1 .135 1.32L6 14.667H3.333a2 2 0 0 1-2-2"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })